import { IOptions } from "../types";
import { OPTIONS_KEY, DEFAULT_OPTIONS } from "./constant";

export const getOptionsFromLocal = (): IOptions => {
  try {
    if (typeof window !== "undefined") {
      const options = localStorage.getItem(OPTIONS_KEY);
      if (options) {
        return {...DEFAULT_OPTIONS, ...JSON.parse(options)};
      }
    }
    return DEFAULT_OPTIONS;
  } catch (error) {
    console.error("getOptionsFromLocal error", error);
    return DEFAULT_OPTIONS;
  }
};

export const setOptionsToLocal = (options: IOptions) => {
  try {
    if (typeof window !== "undefined") {
      localStorage.setItem(OPTIONS_KEY, JSON.stringify(options));
    }
  } catch (error) {
    console.error("setOptionsToLocal error", error);
  }
};
